import React from 'react'
import StyledColumns from './style'

const Columns = ({ children, cols }) => {
  return <StyledColumns cols={cols}>{children}</StyledColumns>
}
export { Columns }
